<template>
    <div class="client">
        <base-form class="client__form">
            <base-card class="client__details">
                <template #card__title >
                    {{ $t('global.details') }}
                </template>
                <template #card__body >
                    <div class="client__body display--grid page--single__grid">
                        <base-field
                            class="client__body__name"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.name') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'name',
                                    name: 'name',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.name,
                                    browserAutocomplete: 'name',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.name,
                                    errorOnSubmit: {
                                        show: errors.api.name ? true : false,
                                        messages: errors.api.name
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="client__body__email"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.email') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'email',
                                    name: 'email',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: email,
                                    browserAutocomplete: 'email',
                                    fileValidation: 'basicEmail',
                                    errors: [{
                                        type: 'email', warning: $t('error.email')
                                    }],
                                    errorOnSubmit: {
                                        show: errors.api.email ? true : false,
                                        messages: errors.api.email
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="client__body__mobile"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.mobile') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'mobile',
                                    name: 'mobile',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: mobile,
                                    browserAutocomplete: 'mobile',
                                    errorOnSubmit: {
                                        show: errors.api.mobile ? true : false,
                                        messages: errors.api.mobile
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="client__body__phone"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.phone') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'phone',
                                    name: 'phone',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: phone,
                                    browserAutocomplete: 'phone',
                                    errorOnSubmit: {
                                        show: errors.api.phone ? true : false,
                                        messages: errors.api.phone
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="client__body__site"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.website') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'website',
                                    name: 'website',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.website,
                                    browserAutocomplete: 'website',
                                    fileValidation: 'website',
                                    errors: [{
                                        type: 'validateWebsite', warning: $t('error.validateWebsite')
                                    }],
                                    errorOnSubmit: {
                                        messages: errors.api.website
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="client__body__state"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.state') },
                                input: {
                                    component: 'States',
                                    name: 'state',
                                    value: stateId || 1,
                                    dynamicData: {
                                        states: [ 1, 2 ]
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: isEdition
                            }"
                        />
                        <base-field
                            class="client__body__independent"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.independentCaller') },
                                input: {
                                    component: 'InputToggle',
                                    name: 'independentCaller',
                                    id: 'independentCaller',
                                    value: model.independentCaller ? 1 : 0
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                    </div>
                </template>
            </base-card>
        </base-form>
        <template v-if="!$route.meta.isAdd">
            <base-card class="client__campaigns page--single__space">
                <template #card__title >
                    <base-card-header
                        :title="$t('global.campaigns')"
                        :actions="{
                            create: { model: 'campaigns' },
                            see: {
                                show: model.viewMoreCampaigns,
                                link: `/campaigns?clientId=${model.id}`
                            }
                        }"
                    />
                </template>
                <template #card__body >
                    <template v-if="haveCampaigns">
                        <list
                            :data="{
                                list: model.campaigns,
                                headers: [
                                    { type: 'default', value: 'beginDate' },
                                    { type: 'default', value: 'endDate' },
                                    { type: 'default', value: 'type' },
                                    {
                                        type: 'component',
                                        value: 'progress',
                                        component:
                                            () => import( /* webpackChunkName: 'ProgressBar' */ '@/components/bundles/bars/progress/ProgressBar' )
                                    }, {
                                        type: 'component',
                                        translate: 'state',
                                        value: 'id',
                                        component: () => import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' )
                                    }
                                ],
                                destak: 'name',
                                model: 'campaigns',
                                hidePagination: true
                            }"
                        />
                    </template>
                    <div v-else class="client__noassociations">{{ $t('global.noAssociations', { type: $t('global.campaigns') })}}</div>
                </template>
            </base-card>
            <base-card class="client__users">
                <template #card__title >
                    <base-card-header
                        :title="$t('global.users')"
                        :actions="{
                            create: { model: 'users' },
                            see: {
                                show: model.viewMoreUsers,
                                link: `/users?clientId=${model.id}`
                            }
                        }"
                    />
                </template>
                <template #card__body >
                    <template v-if="haveUsers">
                        <list
                            :data="{
                                list: model.users,
                                headers: [
                                    {
                                        type: 'component',
                                        value: 'contacts',
                                        component: () => import( /* webpackChunkName: 'BaseContacts' */ '@/components/bundles/contacts/BaseContacts' )
                                    },
                                    { type: 'default', value: 'role', isNecessaryTranslate: true },
                                    {
                                        type: 'component',
                                        translate: 'state',
                                        value: 'id',
                                        component: () => import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' )
                                    }
                                ],
                                destak: 'name',
                                model: 'users',
                                hidePagination: true
                            }"
                        />
                    </template>
                    <div v-else class="client__noassociations">{{ $t('global.noAssociations', { type: $t('global.users') })}}</div>
                </template>
            </base-card>
            <base-card class="client__tokens page--single__space" :add-margins="false">
                <template #card__title >
                    <base-card-header
                        :title="$t('global.tokens')"
                        :actions="{
                            create: { model: 'tokens', modal: true, block: $store.getters.isInEditMode },
                            see: { show: false }
                        }"
                    />
                </template>
                <template #card__body >
                    <base-table
                        :headers="[
                            'id',
                            'name',
                            'createdAt',
                            'expiresAt'
                        ]"
                        :list="model.accessTokens"
                        model="token"
                        :settings="{
                            component: 'RowTokens',
                            warning: $t('global.tokens')
                        }"
                    />
                </template>
            </base-card>
        </template>
        <modal
            v-if="showModal"
            :form="{
                settings: {
                    typeOfPreparation: 'token'
                }
            }"
            :customSettings="{ color: 'green' }"
            :executeCloseAction="!loading"
            @close="showModal = false"
            :key="showModal"
        >
            <template #modal__header >
                {{ $t('global.generateToken') }}
            </template>
            <template #modal__body >
                <transition name="fade" mode="out-in">
                <div v-if="!token.value" class="client__modal__body display--grid page--single__half">
                    <base-field
                        class="client__modal__body__token"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.name') },
                            input: {
                                component: 'InputBasic',
                                id: 'tokenName',
                                name: 'tokenName',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: '',
                                browserAutocomplete: 'tokenName',
                                isRequired: $route.meta.isAdd,
                                isMissing: errors.missing.tokenName,
                                errorOnSubmit: {
                                    show: errors.api.tokenName ? true : false,
                                    messages: errors.api.tokenName
                                },
                                noListener: true
                            },
                            allowFilling: true
                        }"
                    />
                    <base-field
                        class="client__modal__body__expires"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.expiresAt') },
                            input: {
                                component: 'InputCalendar',
                                name: 'expiresAt',
                                id: 'expiresAt',
                                targetClass: 'field__input--default typography--default color--default',
                                value: '',
                                browserAutocomplete: 'off',
                                errorOnSubmit: {
                                    show: errors.api.expiresAt ? true : false,
                                    messages: errors.api.expiresAt
                                },
                                noListener: true
                            },
                            allowFilling: true
                        }"
                    />
                </div>
                <template v-else>
                    <div
                        class="client__modal__token field__input position--relative pointer"
                        @mouseenter="token.tooltip.show = true"
                        @mouseleave="token.tooltip.show = false"
                        @click="copyToClipboard"
                    >
                        {{ token.value }}
                        <tooltip
                            v-show="token.tooltip.show"
                            class="client__modal__token__tooltip"
                            :class=" {
                                [`client__modal__token__tooltip--style client__modal__token__tooltip--${token.tooltip.class}`]: token.tooltip.show
                            }"
                            direction="top"
                            arrow="center"
                            v-html="token.tooltip.label ? $t(`global.${token.tooltip.label}`) : ''"
                        />
                    </div>
                </template>
                </transition>
                <input id="newToken" type="hidden" :value="token.value">
            </template>
            <template #modal__info >
            <transition name="fade" mode="out-in">
                <div v-if="token.value" class="client__modal__token__info">
                    {{ $t('global.tokenInfo') }}
                </div>
            </transition>
            </template>
        </modal>
        <widget-options v-if="!$route.meta.isAdd" />
    </div>
</template>

<script>
// package
import { reactive, toRefs, watch } from '@vue/composition-api';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';
import { getContacts } from '@/hooks/use-contacts';
import copy from '@/hooks/use-copy';

// store
import { storePayload, mapState, useActions } from '@/hooks/use-store';

// renderless
import { showModal } from '@/components/bundles/functional/Modal';

export default {
    components: {
        ...singleStructure.components,
        BaseCardHeader: () => import( /* webpackChunkName: 'BaseCardHeader' */ '@/components/bundles/cards/BaseCardHeader' ),
        List: () => import( /* webpackChunkName: 'List' */ '@/components/bundles/layout/lists/List' ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseTable: () => import( /* webpackChunkName: 'BaseTable' */ '@/components/bundles/tables/BaseTable' ),
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props ) {
        const state = reactive({
            stateId: 1,
            users: []
        });

        const contacts = reactive({
            email: '',
            mobile: '',
            phone: ''
        });

        const bool = reactive({
            haveCampaigns: false,
            haveUsers: false,
            haveTokens: false
        });

        const structureData = newModel => {
            if ( !Object.keys( newModel ).length )
                return;

            // obtenção dos contactos proveniente da API.
            getContacts({ apiContacts: newModel.contacts, contacts });

            // definição do helper.
            const { actions } = useActions();
            actions( 'saveHelper', { contacts: newModel.contacts }); // TODO: validar se é necessário actualizar na edição

            bool.haveCampaigns = newModel.campaigns.length;
            bool.haveUsers = newModel.users.length;
            bool.haveTokens = newModel.accessTokens.length;

            state.stateId = newModel.state.id;
        };

        useData( props, structureData );

        // comportamento do bloco
        // do token na modal.
        const token = reactive({
            value: null,
            tooltip: {
                show: false,
                label: 'clickToCopy',
                class: 'big'
            }
        });

        let timer = '';

        // copiar o token para o clipboard
        const copyToClipboard = () => {
            clearTimeout( timer );
            copy( document.getElementById( 'newToken' ) );

            // troca a label da tooltip
            token.tooltip.label = 'coppied';
            token.tooltip.class = 'small';

            // passado 1 segundo e meio volta
            // a definir os valores base da tooltip.
            timer = setTimeout( () => {
                token.tooltip.class = 'big';
                token.tooltip.label = '';
                setTimeout( () => {
                    token.tooltip.label = 'clickToCopy';
                }, 250 );
            }, 1500 );
        };

        // clear do token quand é fechado
        // a modal.
        const show = reactive({
            modal: showModal
        });

        watch( () => show.modal,
            newShowModal => {
                if ( !newShowModal && token.value )
                    token.value = '';
            });

        // store
        const store = reactive({
            blocks: mapState({ module: 'storePayload', key: 'blocks' })
        });

        const loading = mapState({ module: 'storePayload', key: 'loading' });

        /**
         * [method]
         * Manipular token.
         * Conforma a acção executada pelo utilizador ( adicionar, update ou delete )
         * vai actualizar a listagem de tokens.
         *
         * @param {Object} data
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const handlerToken = {
            new: data => {
                props.model.accessTokens = [ data, ...props.model.accessTokens ];
                token.value = data.accessToken;
                bool.haveTokens = true;
            },
            update: data => {
                props.model.accessTokens.forEach( accessToken => {
                    if ( accessToken.id === data.id )
                        accessToken.revoked = data.revoked;
                });
            },
            delete: data => {
                props.model.accessTokens = props.model.accessTokens.filter( accessToken => accessToken.id !== data.id );
            }
        };

        // listener para quando existe
        // update de algum bloco do modelo.
        watch( () => store.blocks,
            newBlocks => {
                if ( Object.keys( newBlocks ).length )
                    handlerToken[newBlocks.token.type]( newBlocks.token.data );
            });

        // obtenção da store errors & reset
        const { errors, reset } = storePayload();

        return {
            ...toRefs( state ),
            ...toRefs( contacts ),
            ...toRefs( bool ),
            token,
            errors,
            reset,
            showModal,
            copyToClipboard,
            loading
        };
    }
};
</script>

<style lang="scss">
    .client {
        &__modal {
            &__token {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding: 20px;
                @include rounded-corner( 22px );
                &__tooltip {
                    opacity: 0;
                    @include transform-position( false, false, false, 50%, translateX( -50% ) );
                    @include transition( width .3s ease-in-out );
                    &--style {
                        height: 23px;
                        opacity: 1;
                    }
                    &--big {
                        width: 152px;
                    }
                    &--small {
                        width: 80px;
                    }
                }
                &__info {
                    transition-delay: .4s;
                }
            }
        }
    }
</style>